import { Box, Button, Container, Paper, Typography } from '@mui/material'
import React from 'react'

const BannerCustom = (props) => {
  return (
    <Paper sx={{ backgroundColor: "primary.main", borderRadius: 0, width: "100%"}}>
      <Container>
        <Box sx={{py:5, textAlign: "center"}}>
          <Typography color="white" component="h2" fontWeight={600} fontSize={40} variant="h2">Custom Solutions</Typography>
          <Typography color="white" sx={{mt:1,}}>
            Do you need a bespoke tool that illustrates your products, automates the design process and produces a bill of materials?
          </Typography>
          <Typography color="white" fontStyle="italic" sx={{mt:1}}>
            We have you covered for that too. 
          </Typography>
          <Button color="white" variant="contained" href="#contact-us" sx={{mt:2.5,}}>Contact Us</Button>
        </Box>
      </Container>
    </Paper>
  )
}

export default BannerCustom